import React from "react";
import Column from "@amzn/meridian/column";
import Card from "@amzn/meridian/card";
import Heading from "@amzn/meridian/heading";
import Text from "@amzn/meridian/text";
import Button from "@amzn/meridian/button";
import Row from "@amzn/meridian/row";
import Icon from "@amzn/meridian/icon";
import checkCircleFilledTokens from "@amzn/meridian-tokens/base/icon/check-circle-filled";
import { VerticalLine } from "../../vertical-line/VerticalLine";
import Box from "@amzn/meridian/box";

interface PropertyCardProps {
    isAdded: boolean;
    onAdd: () => void;
    onRemove: () => void;
    onViewDetails: () => void;
    address: string;
    location: string;
    sqft: number;
    age: number;
    distance: string;
    year: number;
}

export const PropertyCard: React.FC<PropertyCardProps> = ({
    isAdded,
    onAdd,
    onRemove,
    address,
    location,
    sqft,
    age,
    distance,
    year,
    onViewDetails,
}) => {
    return (
        <Card width={"22rem"} spacingInset="none">
            <Box height="12rem" width="100%" overflowY="hidden">
                <Column height="100%" spacing="none">
                    <Box height="8rem">
                        {" "}
                        <Column spacingInset="400" spacing="300">
                            <Row widths={["fill", "fit"]} alignmentVertical={"top"}>
                                <Box>
                                    {" "}
                                    <Heading level={2} type="h200">
                                        {address}
                                    </Heading>
                                </Box>
                                {isAdded && (
                                    <Box>
                                        {" "}
                                        <Icon tokens={checkCircleFilledTokens} color="success" />
                                    </Box>
                                )}
                            </Row>

                            <Text type="b200">{location}</Text>

                            <Row spacing="300" widths={"fill fill fill fill"}>
                                <Text type="b200" color={"secondary"}>
                                    {sqft.toLocaleString()} sqft
                                </Text>
                                <VerticalLine height={20} />
                                <Text type="b200" color={"secondary"}>
                                    {age} y/o
                                </Text>
                                <VerticalLine height={20} />
                                <Text type="b200" color={"secondary"}>
                                    {distance || "0"} mi away
                                </Text>
                                <VerticalLine height={20} />
                                <Text type="b200" color={"secondary"}>
                                    {year}
                                </Text>
                            </Row>
                        </Column>
                    </Box>

                    <Box height="4rem">
                        {" "}
                        <Column spacingInset="400">
                            <Row widths={["fit", "fit"]} spacing="300">
                                {isAdded ? (
                                    <Button
                                        type="secondary"
                                        onClick={onRemove}
                                        size={"small"}
                                        minWidth={100}
                                    >
                                        Remove
                                    </Button>
                                ) : (
                                    <Button
                                        type="tertiary"
                                        onClick={onAdd}
                                        size={"small"}
                                        minWidth={100}
                                    >
                                        Add
                                    </Button>
                                )}
                                <Button
                                    type="link"
                                    size={"small"}
                                    onClick={onViewDetails}
                                    minWidth={100}
                                >
                                    View details
                                </Button>
                            </Row>
                        </Column>
                    </Box>
                </Column>
            </Box>
        </Card>
    );
};
